"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    BlogClient: Symbol("BlogClient"),
    BlogRoute: Symbol("BlogRoute"),
    BlogPostRoute: Symbol("BlogPostRoute"),
    BlogPostClient: Symbol("BlogPostClient"),
    BlogTagClient: Symbol("BlogTagClient"),
    BlogTagRoute: Symbol("BlogTagRoute"),
    BlogPostCommentRoute: Symbol("BlogPostCommentRoute"),
    BlogPostCommentClient: Symbol("BlogPostCommentClient"),
    BlogPostFilesStreamsRoute: Symbol("BlogPostFilesStreamsRoute"),
    BlogPostFilesStreamsClient: Symbol("BlogPostFilesStreamsClient"),
    BlogPostFilesBatchRoute: Symbol("BlogPostFilesBatchRoute"),
    BlogPostFilesBatchClient: Symbol("BlogPostFilesBatchClient"),
    BlogPostFilesRoute: Symbol("BlogPostFilesRoute"),
    BlogPostFilesClient: Symbol("BlogPostFilesClient"),
    BlogPostStatusRoute: Symbol("BlogPostStatusRoute"),
    BlogPostStatusClient: Symbol("BlogPostStatusClient"),
    Root: Symbol("Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.BlogClient).to(_1.BlogClient);
    bind(TYPES.BlogRoute).to(_1.BlogRoute);
    bind(TYPES.BlogPostRoute).to(_1.BlogPostRoute);
    bind(TYPES.BlogPostClient).to(_1.BlogPostClient);
    bind(TYPES.BlogTagRoute).to(_1.BlogTagRoute);
    bind(TYPES.BlogTagClient).to(_1.BlogTagClient);
    bind(TYPES.BlogPostCommentRoute).to(_1.BlogPostCommentRoute);
    bind(TYPES.BlogPostCommentClient).to(_1.BlogPostCommentClient);
    bind(TYPES.BlogPostFilesStreamsRoute).to(_1.BlogPostFilesStreamsRoute);
    bind(TYPES.BlogPostFilesStreamsClient).to(_1.BlogPostFilesStreamsClient);
    bind(TYPES.BlogPostFilesBatchRoute).to(_1.BlogPostFilesBatchRoute);
    bind(TYPES.BlogPostFilesBatchClient).to(_1.BlogPostFilesBatchClient);
    bind(TYPES.BlogPostFilesRoute).to(_1.BlogPostFilesRoute);
    bind(TYPES.BlogPostFilesClient).to(_1.BlogPostFilesClient);
    bind(TYPES.BlogPostStatusRoute).to(_1.BlogPostStatusRoute);
    bind(TYPES.BlogPostStatusClient).to(_1.BlogPostStatusClient);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;
